module.exports = "/lucky-balls/img/bigball/BigBall_024.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_024.png
// module id = 919
// module chunks = 0